import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import OverlayPinboard from '../overlay/OverlayPinboard';

import {pinboardOverlay} from '../../redux/actions';

class Pinboard extends Component {
  dismissOverlay() {
    this.props.pinboardOverlay(false);
  }

  render() {
    return (
      <div>
        {this.props.pinboardOverlayActive && (
          <OverlayPinboard dismissOverlay={() => this.dismissOverlay()} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {pinboardOverlayActive} = state.pinboard;
  return {pinboardOverlayActive};
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      pinboardOverlay,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Pinboard);
